import { createFileRoute } from "@tanstack/react-router"
import { enforceSignupStep } from "@/features/registration-workflow"
import { SignupInstagramPage } from "@/pages/onboarding"

export const Route = createFileRoute("/onboarding/signup-instagram")({
	beforeLoad: () => enforceSignupStep("instagram"),
	component: SignupInstagramPage,
})
